import { ButtonProps, Button as Root } from '@forgeglobal/design-framework';
import { useAnalytics } from '@tcs/common/hooks/analytics';

type Tracking = {
  tracking?: {
    category?: string;
    action?: string;
  };
};

const Button = ({
  tracking,
  onClick,
  ...buttonProps
}: ButtonProps & Tracking) => {
  const { trackEvent } = useAnalytics();
  const { category = 'button_click', action } = tracking || {};

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (action) {
      trackEvent(category, action);
    }
    onClick?.(event);
  };

  return <Root {...buttonProps} onClick={handleOnClick} />;
};

export default Button;
